import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { fadeInOut } from '@domgen/dgx-fe-components/animation';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GA_CONFIG } from '@domgen/dgx-fe-ga';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { EditableArea } from '@magnolia/angular-editor';
import { ApplianceDetailsSteppedWibBenefitsPanelComponent } from '../../components/appliance-details-stepped-wib-benefits-panel/appliance-details-stepped-wib-benefits-panel.component';
import { ApplianceDetailsSteppedWibFormComponent } from '../../components/appliance-details-stepped-wib-form/appliance-details-stepped-wib-form.component';
import { ApplianceDetailsSteppedWibComponentService } from '../../services/appliance-details-stepped-wib-component/appliance-details-stepped-wib-component.service';

@Component({
  templateUrl: './appliance-details-stepped-wib.component.html',
  styleUrls: ['./appliance-details-stepped-wib.component.scss'],
  providers: [ApplianceDetailsSteppedWibComponentService],
  animations: [fadeInOut],
  standalone: true,
  imports: [
    ApplianceDetailsSteppedWibBenefitsPanelComponent,
    ApplianceDetailsSteppedWibFormComponent,
    AsyncPipe,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
  ],
})
@SeoPage()
export class ApplianceDetailsSteppedWibComponent {
  @Input() banner!: CmsArea;
  @Input() main!: CmsArea;

  canadaUrl = 'https://whirlpool.registria.com/en-ca/pr_reg';

  constructor(readonly cs: ApplianceDetailsSteppedWibComponentService) {
    const domainId = inject(GA_CONFIG).domainId;
    this.canadaUrl = `https://${domainId}.registria.com/en-ca/pr_reg`;
  }
}
